export { getMediaAssetsBasePath } from './getMediaAssetsBasePath';

export const MAX_IMAGE_UPLOAD_BYTES = 5 * 1024 ** 2;
